module.exports = __webpack_public_path__ + "static/media/9.ee16c223.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/9.svg
// module id = 175
// module chunks = 0